<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <!-- Orbit HRM: Orbit's usual field (label, rules, message) with the browser's own time box
       inside. oxd's time input opened a picker on every click that rounded the time to its step
       and wrote it back (an empty field became 01:00 AM), and only read typed "hh:mm AM". -->
  <oxd-input-field
    v-bind="$attrs"
    type="input"
    :step="step * 60"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event || null)"
  />
</template>

<script>
export default {
  name: 'TimeInput',
  inheritAttrs: false,
  props: {
    // "HH:mm" (24h), what the API sends and takes
    modelValue: {
      type: String,
      default: null,
    },
    // minutes per press of the arrow keys; any minute can be typed
    step: {
      type: Number,
      default: 15,
    },
  },
  emits: ['update:modelValue'],
  mounted() {
    // oxd-input-field's own "type" picks the component, so the inner box is made a time box here
    const input = this.$el.querySelector('input');
    if (input) input.type = 'time';
  },
};
</script>

<style lang="scss" scoped>
// the native box keeps oxd's look; its clock icon is the browser's own
:deep(input[type='time']) {
  min-height: 2.65rem;
}
</style>
